import { actionCreatorFactory } from '../../core/utils/factories';
import {
  ReportsData,
  ReportsFilterOptionsResponse,
} from '../../models/interfaces';

const actionCreator = actionCreatorFactory('REPORTS');

export type ReportsErrorCode =
  | 'PERMITTING_REPORT_CONFIGURATION'
  | 'PERMITTING_REPORT_INTEGRITY';

export interface ReportsRequestActionPayload {
  errorCode?: ReportsErrorCode;
  requestHash: string;
  requestId: string;
}

export interface ReportsDoneActionPayload<
  T extends ReportsData | ReportsFilterOptionsResponse = ReportsData,
> extends ReportsRequestActionPayload {
  data: T;
}

export type ReportsRequestLifecyclePayload<
  T extends ReportsData | ReportsFilterOptionsResponse = ReportsData,
> = ReportsRequestActionPayload | ReportsDoneActionPayload<T>;

type ReportRequestLifecyclePayload = ReportsRequestLifecyclePayload;

export namespace ReportsActions {
  export const getPermittingOverview =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_PERMITTING_OVERVIEW',
    );

  export const getBPExpiration =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_BP_EXPIRATION',
    );

  export const getDatesAtAGlance =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_DATES_AT_A_GLANCE',
    );

  export const getFilterOptions =
    actionCreator.createAsyncAction<
      ReportsRequestLifecyclePayload<ReportsFilterOptionsResponse>
    >('GET_FILTER_OPTIONS');

  export const getNewClosedProjects =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_NEW_CLOSED_PROJECTS',
    );

  export const getOverdueTasks =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_OVERDUE_TASKS',
    );

  export const getProjectDuration =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_PROJECT_DURATION',
    );

  export const getStructuralPassFail =
    actionCreator.createAsyncAction<ReportRequestLifecyclePayload>(
      'GET_STRUCTURAL_PASS_FAIL',
    );

  export const invalidateReportsData = actionCreator('INVALIDATE_REPORTS_DATA');

  export const setFilters = actionCreator('SET_FILTERS');

  export const setSelectedReport = actionCreator('SET_SELECTED_REPORT');
}
